import Typography from "@/components/atoms/typography";
import usePath from '@/hooks/usePath';
import Link from '@/components/atoms/link';
import Breadcrumb from '@/components/molecules/breadcrumb';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

export type NewsAndEventsSectionProps = {
    data?: any;
};

const NewsAndEventsSection = ({ data }: any) => {
    const foundSection = (data?.sections ?? [])?.find((sec: any) => sec?.hasOwnProperty('section_with_image_text'));
    const path = usePath()?.path;

    const generateBreadcrumbs = () => {
        const pathSegments = path.split('/').filter(Boolean);
        const pathSegmentsWithoutLast = pathSegments.slice(0, -1);

        return [
            ...pathSegments.map((segment, index) => {
                const href = `/${pathSegmentsWithoutLast.slice(0, index + 1).join('/')}/`;
                const isCurrentPage = pathSegments.length - 1 === index;
                return (
                    <span key={segment}>
                        {isCurrentPage ? (
                            <span
                                className="text-[17px] !font-semibold capitalize leading-6 text-black"
                                style={{ cursor: 'default' }} // Ensure no pointer cursor for static breadcrumb
                            >
                                {segment.replace(/-/g, ' ')}
                            </span>
                        ) : (
                            <Link link={href}>
                                <span className="text-[17px] font-normal capitalize leading-6 text-black">
                                    {segment.replace(/-/g, ' ')}
                                </span>
                            </Link>
                        )}
                    </span>
                );
            }),
        ];
    };
    return (
        <div>
            <div
                className={`sm:pb-[80px] 
            relative mx-auto w-full  px-4 md:px-8 lg:px-[80px]`}
            >
                <div className="hidden pt-12 md:!block lg:px-[80px]">
                    <Breadcrumb Separator={<ChevronRightIcon className="w-4" />} className="">
                        <Link link={'/'}>
                            <span className="text-[17px] !font-[300] capitalize leading-6 text-black">
                                Home
                            </span>
                        </Link>
                        {generateBreadcrumbs()}
                    </Breadcrumb>
                </div>
                <div className="sm:my-16 my-8 ">
                    <Typography
                        className={`!font-semibold !text-[28px] !text-primary-black text-center pb-1 text-2xl !leading-[26px]`}
                    >
                        {foundSection?.section_with_image_text?.title}
                    </Typography>
                </div>

            </div>
        </div>
    );
};
export default NewsAndEventsSection;
